import * as couponVoteTypes from "../types/couponVoteTypes";
import * as authTypes from "../types/authTypes";
import * as userTypes from "../types/userTypes";

const initialState = {
  upsertLoading: false,
  removeLoading: false,
  error: null,
  activeCouponId: null,
};

export default function couponVoteReducer(state = initialState, action) {
  switch (action.type) {
    case couponVoteTypes.COUPON_VOTE_UPSERT_REQUEST:
      return {
        ...state,
        upsertLoading: true,
        error: null,
        activeCouponId: action.payload?.couponPublicId || null,
      };
    case couponVoteTypes.COUPON_VOTE_UPSERT_SUCCESS:
      return {
        ...state,
        upsertLoading: false,
        error: null,
        activeCouponId: null,
      };
    case couponVoteTypes.COUPON_VOTE_UPSERT_FAILURE:
      return {
        ...state,
        upsertLoading: false,
        error: action.payload,
        activeCouponId: null,
      };

    case couponVoteTypes.COUPON_VOTE_REMOVE_REQUEST:
      return {
        ...state,
        removeLoading: true,
        error: null,
        activeCouponId: action.payload?.couponPublicId || null,
      };
    case couponVoteTypes.COUPON_VOTE_REMOVE_SUCCESS:
      return {
        ...state,
        removeLoading: false,
        error: null,
        activeCouponId: null,
      };
    case couponVoteTypes.COUPON_VOTE_REMOVE_FAILURE:
      return {
        ...state,
        removeLoading: false,
        error: action.payload,
        activeCouponId: null,
      };

    case couponVoteTypes.COUPON_VOTE_CLEAR:
    case userTypes.USER_CLEAR:
    case authTypes.LOGOUT:
      return { ...initialState };

    default:
      return state;
  }
}
